<template>
  <QCarousel
    v-model="slide"
    vertical
    transition-prev="slide-down"
    transition-next="slide-up"
    infinite
    autoplay
    swipeable
    animated
    height="228px"
    class="p-2 rounded flex items-center justify-center gap-3 dark:bg-dark-3 light:bg-light-3"
  >
    <QCarouselSlide
      v-for="(items,index) in data"
      :name="index"
      class="!p-0 w-full flex flex-col flex-nowrap gap-2"
    >
      <div
        v-for="item in items"
        class="w-full rounded overflow-hidden"
      >
        <div class="flex items-center flex-nowrap dark:bg-dark-0 light:bg-light-0">
          <div class="bg-primary p-2">
            <QIcon
              name="star"
              color="secondary"
              size="15px"
            />
          </div>
          <div class="px-4 grid">
            <span class="truncate">{{ item.title }}</span>
          </div>
        </div>
        <div class="px-6 py-2 flex flex-nowrap gap-6 justify-between dark:bg-dark-2 light:bg-light-2">
          <div class="grid flex-1">
            <span class="truncate">{{ getHtmlText(item.content).length <= 0 ? '&nbsp;' : getHtmlText(item.content) }}</span>
          </div>
          <div class="text-right">
            {{ dayjs(item.published_at).format('YYYY-MM-DD') }}
          </div>
        </div>
      </div>
    </QCarouselSlide>
  </QCarousel>
</template>

<script setup>
import { dayjs, getHtmlText } from '@/utils/index.js'
import { chunk } from 'lodash-es'
import { computed, ref } from 'vue'
import { useAnnouncementStore } from '@/stores/announcement.js'

const announcementStore = useAnnouncementStore()

const data = computed(() => chunk(announcementStore.data, 3))

const slide = ref(1)
</script>
